import Vue from 'vue';

export const EventBusEvents = {
  rerenderApp: 'rerender-app',
  localeChanged: 'locale-changed'
}

export const EventBus = new Vue();